export enum ObservableAction {
  /**
   * User has switched to another tab or app.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
   */
  PageHidden = 'page_hidden',

  /**
   * User switched back to our tab.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
   */
  PageVisible = 'page_visible',

  ChatMessageSent = 'chat_message_sent',
  AckReceived = 'ack_received',
}

export type ObservableActionContext = Record<string, unknown>;

/**
 * This is a typed subset of DataDog RUM.
 *
 * It allows us to control how we use RUM in our code,
 * and easily add another vendor (alternative to DataDog) in the future.
 */
export type Observability = {
  action: (
    name: ObservableAction,
    context?: ObservableActionContext | undefined,
  ) => void;
};
